import { render } from "./AccountSettingAboutIndex.vue?vue&type=template&id=25f15955"
import script from "./AccountSettingAboutIndex.vue?vue&type=script&lang=js"
export * from "./AccountSettingAboutIndex.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__